import { fetchCreateCpdDraft, TCreateCpdDraftRequest } from '../../../repositories/cpd/v1/create-cpd-draft';
import { IDealsLeadFormValues } from '../../../types/dealsForm';
import { TThunkAction } from '../../../types/redux';
import { mappers } from './mappers';

/**
 * Отправляет заявку «Циан Сделки» в create-cpd-draft:
 * телефон, регион и статья как источник лида.
 */
export const submitDealsLead = ({ phone, regionId }: IDealsLeadFormValues): TThunkAction<Promise<boolean>> => {
  return async (_dispatch, _getState, context) => {
    const { httpApi, logger } = context;

    try {
      const parameters: TCreateCpdDraftRequest = {
        phone,
        regionId: regionId == null ? undefined : Number(regionId),
        source: 'cpdJournal',
      };

      const result = await fetchCreateCpdDraft({
        httpApi,
        parameters,
        mappers,
      });

      return result === true;
    } catch (error) {
      logger.error(error instanceof Error ? error : new Error(String(error)), {
        domain: 'actions.submitDealsLead',
      });

      return false;
    }
  };
};
